import { createApp } from 'vue'
import App from './App.vue'
import router from "./router/index.js";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'swiper/css';
import '@/assets/css/style.css';
import '@/assets/css/responsive.css';
import '@/assets/css/brand.css';

import $ from 'jquery';

window.$ = $;
window.jQuery = $

import 'bootstrap';

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import { createBootstrap } from 'bootstrap-vue-next';
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';
import i18n from './i18n';
import { fetchTranslations } from './services/translationService';

import { bootstrapAuth } from "@/services/auth";
import { getStorage, setStorage } from './services/storage';
import store from './store';
const options = {
  position: "top-right",
  timeout: 3000,
  closeOnClick: true,
}

const bootApp = async () => {
  const app = createApp(App);
  // setting locale
  const locale   = getStorage('locale') || 'en';
  
  // fetch langman strings from backend
  Promise.all([
    fetchTranslations('en'),
    fetchTranslations('he'),
  ]).then(([en, he]) => {
    i18n.global.setLocaleMessage('en', en);
    i18n.global.setLocaleMessage('he', he);
  });
  i18n.global.locale.value = locale;

  app.use(store);
  app.use(router);
  app.use(Toast, options);
  app.use(createBootstrap())
  app.use(VueTelInput)
  app.use(i18n)

  store.watch(
    state => state.locale,
    (newLocale) => {
      i18n.global.locale.value = newLocale
      document.documentElement.dir = newLocale === 'he' ? 'rtl' : 'ltr'
    }
  )

  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');

  if (token) {
    bootstrapAuth(token);
    router.replace({
      path: window.location.pathname,
      query: {
        from:params.get('from')??''
      }
    });
  }
  const lang = params.get('lang') || locale;

  if (lang) {
    setStorage('locale', lang);
    store.dispatch('setLocale', lang);
  }
  app.mount('#app');
};
bootApp();